import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNotificationHub = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNotificationHub);
};
